import {useSelector} from 'react-redux';

import {getTotalsShippingProtection} from '../../store/selectors/orderReviewTotals/orderReviewTotals';

/**
 * Check if shipping protection in the cart
 */
export const useShippingProtectionEnabled = () => {
    const shippingProtection = useSelector(getTotalsShippingProtection);

    return {
        isEnabled: Boolean(shippingProtection),
        price: shippingProtection?.price,
    };
};
